import { Injectable } from '@angular/core';

import { EncryptionService } from './encryption.service';

@Injectable()
export class StorageService{
    constructor(
        private _encryptionService: EncryptionService
    ){}

    setToken(key, value, remember){
		if(remember === false) {
            this.setSessionItem(key,value);
        }else {
            this.setLocalItem(key,value);
        }
    }

    getToken(key){
        let token = this.getLocalItem(key);

        /*if(token !== null || token !== undefined) {
            token = this.getSessionItem(key);
            return token;
        }*/

        return token;
    }

    setLocalItem(key, value){
		let valueEncryptedString = this._encryptionService.encryptStorage(value);

		localStorage.setItem(key, valueEncryptedString);
    }

    getLocalItem(key){
        var value = localStorage.getItem(key);

        if(value === null || value === undefined){
            return value;
        }

        let valueDecrypted = this._encryptionService.decryptStorage(value);
        return valueDecrypted;
    }

    removeItem(key){
        localStorage.removeItem(key);
    }

    clearAll(){
        localStorage.clear();
    }

    setSessionItem(key, value){
		let valueEncryptedString = this._encryptionService.encryptStorage(value);

		sessionStorage.setItem(key, valueEncryptedString);
    }

    getSessionItem(key){
        var value = sessionStorage.getItem(key);

        if(value === null || value === undefined){
            return value;
        }

        let valueDecrypted = this._encryptionService.decryptStorage(value);
        return valueDecrypted;
    }

    removeSessionItem(key){
        sessionStorage.removeItem(key);
    }

    clearAllSession(){
        sessionStorage.clear();
    }

}


// WEBPACK FOOTER //
// /home/maheshreddy/PRP_FE/src/app/shared/services/storage.service.ts